import Header from './Header';
import { Outlet } from 'react-router-dom';

export default function DefaultLayout() {
    return (
        <main className="font-cairo md:min-h-screen">
            <div className="relative flex min-h-screen w-full flex-col">
                <Header />
                <div className="m-auto flex-grow w-full px-3 custom:px-0 custom:w-[1240px]">
                    <Outlet />
                </div>
            </div>
        </main>
    );
}
